import React from "react";
import "./usedObject.scss";
import { RxCross2 } from "react-icons/rx";
import Spinner from "react-bootstrap/Spinner";
import notFound from "../../assets/images/common/image-not-found.png";
import { useNavigate } from "react-router-dom";
import {
  ADD_CONSERVATION,
  ADMIN_DETAIL,
  EDIT_OBJECT,
  EDIT_PHOTOGRAPHY,
} from "../../constants/routers";
import { checkPermission } from "../../helpers/permissions";
import InfiniteScroll from "react-infinite-scroll-component";

const UsedObject = ({
  usedObjectFilter,
  selectedMaterial,
  selectedCategory,
  objectLoader,
  isOpenObject,
  setIsOpenObject,
  relatedData,
  hasMoreObject,
  fetchNextObject,
}) => {
  const navigate = useNavigate();
  const userData = JSON.parse(localStorage.getItem("user_info"));

  const redirectHandler = (row) => {
    const basePath = `/${
      userData?.museum_name?.split(" ").join("_") || "Nefos"
    }`;

    const routes = {
      collection_change_object: EDIT_OBJECT,
      photogrophy_change_object: EDIT_PHOTOGRAPHY,
      conservation_change_object: ADD_CONSERVATION,
    };

    const permission = Object.keys(routes).find(checkPermission);
    const path = routes[permission] || ADMIN_DETAIL;
    let usedObjectData = null;
    if (usedObjectFilter?.material) {
      usedObjectData = {
        objectListFormik: usedObjectFilter,
        fromUsedObject: true,
        fromMaterial: true,
      };
    } else {
      usedObjectData = {
        objectListFormik: usedObjectFilter,
        fromUsedObject: true,
        fromCategory: true,
      };
    }

    navigate(`${basePath}/${path}/${row?.value}`, {
      state: usedObjectData,
    });
  };

  return (
    <div className="object-cat-container">
      <div
        style={{
          padding: "20px",
        }}
        className="object-cat-heading"
      >
        <h3>
          Objects
          <span style={{ fontSize: "17px", marginLeft: "15px" }}>
            (
            {selectedCategory?.category_name ? (
              <>
                {selectedCategory.category_name}
                {" : "}
                <span style={{ color: "gray" }}>
                  {selectedCategory.category_code}
                </span>
              </>
            ) : (
              selectedMaterial?.material_name
            )}
            )
          </span>{" "}
        </h3>

        <div className="closeIcon" onClick={() => setIsOpenObject(false)}>
          <RxCross2 fontSize={"22px"} />
        </div>
      </div>

      <div id="object-cat-list" className="object-cat-list">
        {objectLoader ? (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              marginTop: "200px",
            }}
          >
            <Spinner animation="border" />
          </div>
        ) : relatedData?.length > 0 ? (
          <InfiniteScroll
            loader={
              <h6 style={{ textAlign: "center", margin: "10px" }}>
                <Spinner />
              </h6>
            }
            next={fetchNextObject}
            hasMore={hasMoreObject}
            dataLength={relatedData?.length}
            scrollableTarget="object-cat-list" // 👈 important
          >
            {relatedData.map((li, idx) => (
              <div
                onClick={() => redirectHandler(li)}
                className="object-cat-card"
                key={li?.id || idx}
              >
                <div className="crd-left">
                  <div className="img-container-used">
                    <img
                      onError={(e) => (e.currentTarget.src = notFound)}
                      src={li?.image_thumbnail}
                      alt="objct-img"
                    />
                  </div>
                  <div className="crd-mid">
                    <b>{li?.label}</b>
                  </div>
                </div>
                <div className="crd-right">
                  <span>{li?.accession_number}</span>
                </div>
              </div>
            ))}
          </InfiniteScroll>
        ) : (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              marginTop: "100px",
            }}
          >
            <b>No related data found.</b>
          </div>
        )}
      </div>
    </div>
  );
};

export default UsedObject;
